import { EIP712Base } from "../bases/EIP712Base";
import { VersionBase } from "../bases/VersionBase";
import { CallId_oldVersion } from "./CallId";
import { SessionId_oldVersion } from "./SessionId";
import { Utils_oldVersion } from "./Utils";
export class Version_old extends VersionBase {
    SessionId;
    CallId;
    EIP712;
    Utils;
    batchMultiSigSelector = "0x7d971612";
    constructor(FCT) {
        super(FCT);
        this.SessionId = new SessionId_oldVersion(FCT);
        this.CallId = new CallId_oldVersion(FCT);
        this.EIP712 = new EIP712Base();
        this.Utils = new Utils_oldVersion(FCT);
    }
}
//# sourceMappingURL=index.js.map